/**
 *
 * Notes: May, 2019
 * Original source code pulled (and edited) from previous website.
 * Assuming this was custom developed by previous vendor since license was not provided.
 *
 */

import $ from 'jquery';

export default BasicCalculator;

function BasicCalculator ( element ) {

    var $container = $(element),
        $output = $container.find(".display span"),
        $mode = $container.find(".mode span"),
        stack = [],
        displayLimit = 12;

    $container.find(".calc-but").click(function() {
        interpret($(this).attr("data-id"));
    });
    doClear();

    function toggleSign(s) {
        if (s == null || s == "0") return s;
        // if (s == null || s == "0") return "0";
        return (s.indexOf("-") == 0) ? s.substr(1) : "-" + s;
    }

    function insertDecimal(s) {
        s = (s == null || !s) ? "0" : s;
        if (s.indexOf(".") >= 0) return s;
        return s + ".";
    }

    function limitDigits(s) {
        var cnt = 0;
        var len = s.length;
        for (var i = 0; i<len; i++) {
            var c = s.charAt(i);
            if (c == String(Number(c))) {
                cnt++;
            }
            if (cnt > displayLimit) {
                return s.substr(0, i);
            }
        }
        return s;
    }

    function concatDigits(s1, s2) {
        var s = (s1 == null || s1 == "0") ? s2 : s1 + s2;
        return limitDigits(s);
    }

    function calculate(n1, n2, operator, nextOperator){
        var r;
        switch (operator) {
            case "+" :
                r = n1 + n2;
                break;
            case "-" :
                r = n1 - n2;
                break;
            case "*" :
                r = n1 * n2;
                break;
            case "/" :
                r = n1 / n2;
                break;
            default :
                r = n2;
        }
        if (Number(r).toPrecision(displayLimit).indexOf("e") >= 0) {
            // ERROR: Too many digits.
            r = "ERR";
        } else {
            // TO DO: Prevent exponential notation for small numbers
            r = Number(r);
        }
        // TO DO: Stack maintenance shouldn't occur in calculate function.
        doClear();
        stack.unshift(r);
        if (nextOperator) {
            stack.unshift(nextOperator);
        }
        evaluateStack();
    }

    function evaluateStack() {
        // TO DO: Collapse array as it is evaluated. No reason to store all key presses.
        var nums = []; // The operands
        var ops = []; // The operators

        var len = stack.length;
        for (var i = len - 1; i>=0; i--) {
            var e = stack[i];
            var n = (ops[0] == null) ? 0 : 1; // Index of the current operand (nums)
            var o = (nums[1] == null) ? 0 : 1; // Index of the current operator (ops)
            if (isNaN(Number(e))) {
                // Element is not a number
                switch (e) {
                    case "ERR" :
                        $output.text(e);
                        return;
                    case "±" :
                        nums[n] = toggleSign(nums[n]);
                        break;
                    case "." :
                        nums[n] = insertDecimal(nums[n]);
                        break;
                    default :
                        // Element is an operator
                        ops[o] = e;
                        $mode.text(e);
                        $mode.removeClass("invisible");
                        // display.mode = e;
                        if (o == 1) {
                            // We've encountered a second operator, so do a calculation
                            calculate(Number(nums[0]), Number(nums[1]), ops[0], ops[1]);
                            return;
                        }
                }
            } else {
                // Element is a number
                nums[n] = concatDigits(nums[n], e);
                if (n == 1) {
                    // $mode.text("");
                    $mode.addClass("invisible");
                    //display.mode = "";
                }
            }
        }
        $output.text((nums[1] == null) ? String(nums[0]).substr(0, displayLimit) : String(nums[1]).substr(0, displayLimit));
        //$output.text((nums[1] == null) ? String(nums[0]) : String(nums[1]));
    }

    function addToStack(s) {
        stack.unshift(s);
        evaluateStack();
    }

    function doClear() {
        stack = [];
        // $mode.text(" ");
        $mode.addClass("invisible");
        // display.mode = "";
        addToStack(0);
    }

    function interpret(str)
    {
        // Interpret what button has been pressed.
        // Call appropriate function.
        switch (str) {
            case "C" :
                doClear();
                break;
            default :
                // Button is an operator, digit, decimal, sign...
                addToStack(str);
        }
    }
}


// WEBPACK FOOTER //
// ./src/calculators/basic.js